import React, { useState } from "react";
import Card from "components/card";
import SelectOption from "components/select/SelectOption";
import { Activity } from "lucide-react";
import AreaChartBase from "components/charts/AreaChartBase";

const BreakdownCard = ({ employee }) => {
    const [positionFilter, setPositionFilter] = useState(0);

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-slate-200 shadow-lg overflow-hidden dark-mode-card">
            <div className="grid items-start gap-1.5 px-6 pt-6 pb-6 bg-gradient-to-br from-slate-50 to-cyan-50 border-b dark:from-slate-900 dark:to-cyan-900">
                <div className="flex items-center justify-between">
                    <div>
                        <h4 className="text-[18px] dark:text-white">
                            Daily Hours Breakdown
                        </h4>
                        <p className="text-[15px] font-normal text-slate-700 dark:text-slate-200">
                            Last 7 days productivity analysis
                        </p>
                    </div>
                    <SelectOption
                        placeholder="All Departments"
                        className=" w-[150px] border-2 border-slate-300"
                        options={[
                            { label: "This Week", value: 0 },
                            { label: "This Month", value: 1 },
                            { label: "This Quarter", value: 2 },
                        ]}
                        value={positionFilter}
                        onChange={setPositionFilter}
                    /> 
                </div>
            </div>
            <div className="pb-6 p-6">
                <div className="h-[300px]">
                    <AreaChartBase
                        data={employee?.details?.daily_breakdown?.map(day => ({
                            date: day.date,
                            a:  day.productive,
                            b: day.meetings,
                            c: day.breaks
                        })) || []}
                        xKey="date"
                        yLabel="Hours"
                        stacked={true}
                        showLegend={true}
                        singleArea={false}
                        areas={[
                            { key: "a", color: "#06b6d4", label: "Productive Hours" },
                            { key: "b", color: "#b595ffff", label: "Meeting Hours" },
                            { key: "c", color: "#f59e0b", label: "Break Time" },
                        ]}
                    />
                </div>
                <div className="bg-gray-200 h-px w-full my-6"></div>
                <div className="space-y-2">
                    <h4 className="font-semibold text-[14px] mb-3 dark:text-white">
                        Detailed Daily Breakdown
                    </h4>
                    <div className="grid grid-cols-5 gap-2 text-[11px] font-medium text-slate-700 pb-2 border-b dark:text-slate-100">
                        <span>Date</span>
                        <span className="text-center">Total</span>
                        <span className="text-center">Productive</span>
                        <span className="text-center">Meetings</span>
                        <span className="text-center">Breaks</span>
                    </div>
                    {employee?.details?.daily_breakdown?.map((day, index) => (
                        <div 
                            key={index}
                            className="grid grid-cols-5 gap-2 text-[12px] p-2 rounded-lg hover:bg-slate-50 transition-colors dark:hover:bg-white/10"
                        >
                            <span className="font-medium dark:text-white">{day.date}</span>
                            <span className="text-center font-semibold dark:text-white">{day.total}h</span>
                            <span className="text-center text-cyan-600 font-medium dark:text-cyan-500">{day.productive}h</span>
                            <span className="text-center text-purple-600 font-medium dark:text-purple-300">{day.meetings}h</span>
                            <span className="text-center text-orange-600 font-medium dark:text-orange-300 ">{day.breaks}h</span>
                        </div>
                    ))}
                    <div className="mt-6 p-4 rounded-xl bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-200 dark:from-blue-900 dark:to-cyan-900 dark:border-blue-700">
                        <div className="flex items-start gap-3">
                            <Activity className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 dark:text-blue-500 " />
                            <div className="text-[13px]">
                                <p className="font-semibold text-blue-900 mb-1 dark:text-blue-100">
                                    Productivity Insights
                                </p>
                                <p className="text-blue-800 leading-relaxed dark:text-blue-300">
                                    {employee?.details?.message}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default BreakdownCard;